'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _StreamLogger = require('../services/StreamLogger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _debug = true;

var CwLog = function () {
  function CwLog() {
    (0, _classCallCheck3.default)(this, CwLog);
  }

  (0, _createClass3.default)(CwLog, null, [{
    key: 'setDebug',


    /**
     * Sets debug state
     * @static
     * @param {boolean} debug 
     * @memberof CwLog
     */
    value: function setDebug(debug) {
      _debug = debug;
    }

    /**
     * Informational console log
     * @static
     * @param {any} message 
     * @param {any[]} optionalParams
     * @memberof CwLog
     */

  }, {
    key: 'log',
    value: function log(message) {
      if (_debug) {
        var _console;

        for (var _len = arguments.length, optionalParams = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          optionalParams[_key - 1] = arguments[_key];
        }

        (_console = console).log.apply(_console, [message].concat(optionalParams));
        (0, _StreamLogger.addLogTrackerEvent)('info', message);
      }
    }
  }, {
    key: 'warn',


    /**
     * Warning console log
     * @static
     * @param {any} message 
     * @param {any[]} optionalParams
     * @memberof CwLog
     */
    value: function warn(message) {
      if (_debug) {
        var _console2;

        for (var _len2 = arguments.length, optionalParams = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          optionalParams[_key2 - 1] = arguments[_key2];
        }

        (_console2 = console).warn.apply(_console2, [message].concat(optionalParams));
        (0, _StreamLogger.addLogTrackerEvent)('warn', message);
      }
    }

    /**
     * Error console log
     * @static
     * @param {any} message 
     * @param {any[]} optionalParams
     * @memberof CwLog
     */

  }, {
    key: 'error',
    value: function error(message) {
      if (_debug) {
        var _console3;

        for (var _len3 = arguments.length, optionalParams = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          optionalParams[_key3 - 1] = arguments[_key3];
        }

        (_console3 = console).error.apply(_console3, [message].concat(optionalParams));
        (0, _StreamLogger.addLogTrackerEvent)('error', message);
      }
    }
  }]);
  return CwLog;
}();

exports.default = CwLog;
;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/CwLog.js
// module id = 36
// module chunks = 10